import { IconButton, Icon, Stack, Tooltip, Button, Popover, PopoverTrigger, PopoverContent, PopoverCloseButton, PopoverHeader, PopoverBody, useDisclosure, Text, GridItem, Grid, Center, Badge } from '@chakra-ui/react';
import { useKeyPress } from '../../../../hooks/keyboard';
import { useCallback } from 'react';
import { TbBackpack } from 'react-icons/tb'
import AttachmentImage from '../../../AttachmentImage'
import { Tool } from '../../../../classes/ToolFactory';
import Game from '../../../../classes/Game';
import { CustomRegionAttachment, withGame } from '../../helpers';


function Inventory({ game }: { game: Game}) {

  const { isOpen, onClose, onOpen } = useDisclosure()
  const { isOpen: tooltipOpen, onOpen: onTooltipOpen, onClose: onTooltipClose } = useDisclosure()

  const onToolClick = (t: Tool) => () => game.setHeldItem(t)

  const removeHeldItem = useCallback(() => {
    game.removeHeldItem(true)
  }, [game])

  useKeyPress('Escape', removeHeldItem)


  return (<Tooltip isOpen={tooltipOpen} label={'Inventory'} placement="right" shouldWrapChildren>
        <Popover
          closeOnBlur={false}
          placement="top"
          isOpen={isOpen}
          onClose={onClose}
          closeOnEsc={false}
        >
          <PopoverTrigger>
            <IconButton
              onClick={() => {
                if(isOpen) {
                  onClose()
                  onTooltipOpen()
                } else {
                  onOpen()
                  onTooltipClose()
                }
              }}
              onMouseEnter={() => {
                !isOpen && onTooltipOpen()
              }}
              onMouseLeave={onTooltipClose}
              aria-label="inventory">
              <Icon as={TbBackpack} />
            </IconButton>
          </PopoverTrigger>
          <PopoverContent left={2} maxWidth="200px" maxHeight="530px" onClick={removeHeldItem}>
            <PopoverCloseButton top={2} />
            <PopoverHeader>Inventory</PopoverHeader>
            <PopoverBody overflowY="auto" p={2}>
            {(game.getInventory().length === 0) ? <Text p={2}>
              Your inventory is empty.
            </Text> : null}
            <Grid w="100%" templateColumns="repeat(2, 1fr)" gap={2}>
              {game.getInventory().map(({ tool: t, count }, i) => (<GridItem key={t.name}>
                <Button onClick={e => {
                  onToolClick(t)()
                  e.stopPropagation()
                }} height="90px" borderWidth={1} padding={2} w="100%" bg="white" display="block"  position="relative">
                  <Badge position="absolute" top={1} right={1} colorScheme="red" borderRadius="md">{count}</Badge>
                  <Stack align="center" h="100%">
                    <Center flex={1} mt={4}>
                      <AttachmentImage key={i} attachment={t.attachment as CustomRegionAttachment} width={45} maxHeight={40} />
                    </Center>
                    <Text textTransform="capitalize" fontSize="xs">{t.name}</Text>
                  </Stack>
                </Button>
              </GridItem>))}
            </Grid>


            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Tooltip>)


}


export default withGame(Inventory)


